"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const WidgetError_1 = require("./WidgetError");
const StepNotFoundError_1 = require("./StepNotFoundError");
/**
 * Error thrown when plugin was not found.
 */
class PluginNotFoundError extends WidgetError_1.default {
    constructor(message) {
        super(message);
        // Set the prototype explicitly.
        Object.setPrototypeOf(this, StepNotFoundError_1.default.prototype);
        this.name = this.getCode();
    }
}
/**
 * @inheritDoc
 */
PluginNotFoundError.code = "SW-NOT-FOUND-PLUGIN";
exports.default = PluginNotFoundError;
